import { render, staticRenderFns } from "./DodatneAktivnosti.vue?vue&type=template&id=1357bb2a&scoped=true&"
import script from "./DodatneAktivnosti.vue?vue&type=script&lang=js&"
export * from "./DodatneAktivnosti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1357bb2a",
  null
  
)

export default component.exports